const state = {
  compatible_publication_id: undefined,
  id: null,
  publication_id: undefined,
}

export const requiredFields = [
  { key: 'compatible_publication_id' },
  { key: 'publication_id' },
]

export default state
